module.exports = __webpack_public_path__ + "img/Login-icon.ca21ad31.svg";